module.exports = __webpack_public_path__ + "img/happy.8e5e0d49.png";